import React from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import ActivePage from "../../../partials/active-page";
import { useQuery } from "@apollo/react-hooks";
import { GET_SITE } from "../../../queries/site.query";
import AlertMessage from "../../../partials/alertMessage";
import LoadingSpinner from "../../../partials/loading";
import ViewSite from "./view.jsx";

const SiteDetail = ({ match, history }) => {
    const { id } = match.params;

    const title = "Site Detail";
    const pages = [
        {
            title: "Application Management",
            path: "/home/app-management",
        },
        { title, path: match.path },
    ];
    const { loading, data, error } = useQuery(GET_SITE, { variables: { id } });
    if (!id) return history.goBack();

    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>
            <ActivePage pages={pages} title={title} />
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <LoadingSpinner loading={loading} />
                    <AlertMessage message={error && error.message} failed={true} />
                    {data && <ViewSite currentItem={data.GetSite.doc} onBack={() => history.goBack()} />}
                </div>
            </div>
        </>
    );
};

export default SiteDetail;
